import React, { useState } from "react";
import { saveUserRoleAccess } from "../../service/UserRoleAccessRequest";

import {TextField,
    Button, Box, Container, makeStyles,
} from '@material-ui/core';
import {
    UserRoleAccessFormBottonControl,
} from './style/UserRoleAccessStyle';



const userStyles = makeStyles({
    field: {
        marginTop: 20,
        marginBottom: 10,

    },
});
export default function UserRoleAccessForm({handleAddClose, handleSubmit}) {
    const classes = userStyles();

    const [userId, setUserId] = useState('');
    const [roleId, setRoleId] = useState('');


    const handleSubmitData=async (e) =>{
        e.preventDefault();
        console.log('UserRoleAccessEditForm====');
        console.log('userId===', userId);
        console.log('roleId===', roleId);




        const saveUserRoleAccessDto = {
            'userId': userId,
            'roleId': roleId,
        };
        await saveUserRoleAccess(saveUserRoleAccessDto);

        console.log('===save====');

        handleSubmit();
    };
    return (
        <div>


            <Container >


                <form noValidate autoComplete="off" onSubmit={handleSubmitData}>


                    <Box>
                        <TextField
                            onChange={((e)=> setUserId(e.target.value))}
                            className={classes.field}
                            id="standard-disabled"
                            label="UserId"
                            variant="standard"

                        />

                        <TextField id="roleId" className={classes.field} label="Role Id" onChange={((e)=> setRoleId(e.target.value))} variant="standard"/>
                    </Box>



                    <UserRoleAccessFormBottonControl>
                        <Button type="submit" variant="outlined" className="btn right">Submit</Button>
                        <Button variant ="outlined" onClick={handleAddClose} className="btn right">close</Button>

                    </UserRoleAccessFormBottonControl>

                </form>
            </Container>
        </div>
    );
}

